'use client'

import { ButtonIconTransparent } from '@fukku/button/Icon/Transparent'
import { IconSubmit } from 'icons/components/IconSubmit'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import type { ChangeEvent } from 'react'

import { dataTestIds } from '../../constants/dataTestIds'
import { ids } from '../../constants/ids'

import text from 'fukku/styles/texts.module.scss'
import styles from './InputForm.module.scss'

interface InputFormProps {
	input: string
	onInput: (newMessage: string) => void
	onSubmit: () => void
}

export function InputForm({
	input,
	onInput,
	onSubmit,
}: Readonly<InputFormProps>): React.ReactNode {
	const { t } = useLabels()

	const handleSubmit = (e: React.FormEvent) => {
		e.preventDefault()
		const isInputEmpty = input.trim() === ''
		if (isInputEmpty) {
			return
		}

		onSubmit()
	}

	const handleInput = (event: ChangeEvent<HTMLInputElement>) => {
		const message = event.target.value
		onInput(message)
	}

	return (
		<form className={styles.form} onSubmit={handleSubmit}>
			<input
				aria-label={t('assistant.search.placeholder')}
				className={`${styles.input} ${text.bodyL}`}
				data-testid={dataTestIds.chatbotInputForm}
				id={ids.chatAssistantInputId}
				placeholder={t('assistant.search.placeholder')}
				value={input}
				onInput={handleInput}
				autoComplete='off'
			/>
			<ButtonIconTransparent
				aria-label={t('accessibility.send.button')}
				className={styles.sendButton}
				onClick={handleSubmit}
			>
				<IconSubmit width={14} height={12} />
			</ButtonIconTransparent>
		</form>
	)
}
